"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ShoppingBag = _interopRequireDefault(require("wix-ui-icons-common/on-stage/ShoppingBag"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var FullscreenCartIcon = /*#__PURE__*/function (_React$Component) {
  function FullscreenCartIcon() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(FullscreenCartIcon, _React$Component);
  var _proto = FullscreenCartIcon.prototype;
  _proto.render = function render() {
    var _this = this;
    var count = this.props.cartItemsCount > 0 ? /*#__PURE__*/_react["default"].createElement("span", null, this.props.cartItemsCount) : false;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: 'fullscreen-icon fullscreen-cart-icon has-custom-focus',
      onClick: function onClick() {
        return _this.props.showCart && _this.props.showCart();
      },
      title: 'Cart',
      "aria-label": "Cart",
      tabIndex: 0
    }, /*#__PURE__*/_react["default"].createElement("button", {
      tabIndex: -1
    }, /*#__PURE__*/_react["default"].createElement(_ShoppingBag["default"], {
      size: "24"
    })), count);
  };
  return FullscreenCartIcon;
}(_react["default"].Component);
var _default = exports["default"] = FullscreenCartIcon;